export default __webpack_public_path__ + "static/media/ms-sql-office.914bb40f.svg";